const { getClientConfig } = require('../helpers/utils');

const clientConfig = getClientConfig('cub');

/**
 * Get the current screenId from window.apz.childScr
 * @returns {string} The current screenId in lowercase
 */
function getScreenId() {
  try {
    if (typeof window !== 'undefined' && window.apz && window.apz.childScr) {
      const screenId = String(window.apz.childScr).toLowerCase();
      return screenId;
    }
  } catch (e) {
    // ignore errors
  }
  return '';
}

/**
 * Append screenId to URL if cub client is enabled
 * @param {string} url - The original URL
 * @returns {string} URL with screenId appended
 */
exports.appendScreenIdToUrl = (url) => {
  const currentScreenId = getScreenId();
  if (currentScreenId) {
    // Append /screenId to the URL
    const separator = url.endsWith('/') ? '' : '/';
    return `${url}${separator}${currentScreenId}`;
  }
  return url;
};

/**
 * Perform initialization tasks for this feature
 *
 * @param {object} config Configuration passed by initialization code
 * @param {object} urlObj Document URL object
 */
exports.initialize = async (config, urlObj) => {
  if (urlObj.hostname.includes(clientConfig.hostname[0])) {
    clientConfig.enabled = true;
  }
};

/**
 * Is used to check if the client code is enabled or not.
 *
 * @returns boolean
 */
exports.isEnabled = () => {
  return !!clientConfig.enabled;
};
